var _mask, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendcode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_1737_999",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16344 7.16344 0 16 0H40C48.8366 0 56 7.16344 56 16V40C56 48.8366 48.8366 56 40 56H16C7.16344 56 0 48.8366 0 40V16Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16344 7.16344 0 16 0H40C48.8366 0 56 7.16344 56 16V40C56 48.8366 48.8366 56 40 56H16C7.16344 56 0 48.8366 0 40V16Z",
    fill: "#00BBA7",
    fillOpacity: 0.09
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 0V0.666667H40V0V-0.666667H16V0ZM56 16H55.3333V40H56H56.6667V16H56ZM40 56V55.3333H16V56V56.6667H40V56ZM0 40H0.666667V16H0H-0.666667V40H0ZM16 56V55.3333C7.53163 55.3333 0.666667 48.4684 0.666667 40H0H-0.666667C-0.666667 49.2047 6.79525 56.6667 16 56.6667V56ZM56 40H55.3333C55.3333 48.4684 48.4684 55.3333 40 55.3333V56V56.6667C49.2047 56.6667 56.6667 49.2047 56.6667 40H56ZM40 0V0.666667C48.4684 0.666667 55.3333 7.53163 55.3333 16H56H56.6667C56.6667 6.79526 49.2047 -0.666667 40 -0.666667V0ZM16 0V-0.666667C6.79526 -0.666667 -0.666667 6.79525 -0.666667 16H0H0.666667C0.666667 7.53163 7.53163 0.666667 16 0.666667V0Z",
    fill: "#00BBA7",
    fillOpacity: 0.2,
    mask: "url(#path-1-inside-1_1737_999)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8334 29.083V21.4997C38.8334 20.925 38.6051 20.3739 38.1988 19.9676C37.7925 19.5613 37.2414 19.333 36.6667 19.333H19.3334C18.7588 19.333 18.2077 19.5613 17.8013 19.9676C17.395 20.3739 17.1667 20.925 17.1667 21.4997V34.4997C17.1667 35.6913 18.1417 36.6663 19.3334 36.6663H28.0001",
    stroke: "#00BBA7",
    strokeWidth: 1.89583,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8334 22.583L29.1159 28.758C28.7815 28.9676 28.3948 29.0787 28.0001 29.0787C27.6054 29.0787 27.2187 28.9676 26.8842 28.758L17.1667 22.583",
    stroke: "#00BBA7",
    strokeWidth: 1.89583,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3333 35.5837L34.4999 37.7503L38.8333 33.417",
    stroke: "#00BBA7",
    strokeWidth: 1.89583,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendcode);
export default __webpack_public_path__ + "static/media/sendcode.e4a808233ec62b635208ff47670c1cf3.svg";
export { ForwardRef as ReactComponent };